
class expertHandler {
    constructor(){
        this.attributes = {}
    }

    set_att(name, value){
        this.attributes[name] = value;
    }

    get_att(name){
        return this.attributes[name]
    }

}

const expert_handler = new expertHandler();

export default expert_handler;